<template>
  <div class="children-list">
    <draggable
      id="children-container"
      :class="[{ 'content-background-grid': resizeable }]"
      handle=".drag-handler"
      :list="children"
      @change="$emit('positionChange', $event)"
    >
      <ContentBlock
        v-for="child in children"
        :resizeable="resizeable"
        :key="child.id"
        :child="child"
        @resize="$emit('resize', $event)"
        @click="$emit('click', $event)"
        @delete="$emit('delete', $event)"
      />
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ContentBlock from '@/components/sidenav/shared/ContentBlock'

export default {
  name: 'Content',
  components: {
    draggable,
    ContentBlock,
  },
  props: {
    children: {
      type: Array,
      default() {
        return []
      },
    },
    resizeable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.children-list {
  margin-bottom: 16px;
}

#children-container {
  display: flex;
  flex-wrap: wrap;
  width: 288px;
  margin: 0 auto;
}

.content-background-grid {
  background: url(./../../../assets/grid.png);
}
</style>
